import React, { useState, useContext } from "react";
import SearchBar from "../components/SearchBar";
import RideResults from "../components/RideResults";
import { AuthContext } from "../context/AuthContext";
import googleplay from "../assets/googleplay.avif";
import appstore from "../assets/appstore.jpg";
import saferide from "../assets/whytravelo.png";
import affordableride from "../assets/mission.png";
import flexibleride from "../assets/use-cases.png";
import rideshare1 from "../assets/rideshare1.png";
import logo from "../assets/icon.png";
import HomeExtraSlides from "../components/HomeExtraSlides";
import "../css/home.css";


export default function Home() {
  const { user } = useContext(AuthContext);
  const [filters, setFilters] = useState({
    from: "",
    to: "",
    date: "",
    passengers: "",
  });

  const [showResults, setShowResults] = useState(false);

  const handleSearch = () => {
    setShowResults(true);

  };



  return (
    <div className="container">

      {/* 🌟 HERO 1 - Attractive Landing Banner */}
      {!showResults && (
        <section className="super-hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1 className="hero-title">
              Vyango: Your Journey, Shared.
            </h1>

            <p className="hero-sub">
              Connecting cities, cutting costs, creating your journey.
            </p>

            <div className="hero-buttons">
              <a href="/search" className="btn-primary-hero">
                🚘 Find Your Adventure
              </a>

              <a href="/post" className="btn-secondary-hero">
                Become a Host
              </a>
            </div>
          </div>
        </section>

      )}




      {/* 🔍 Search Bar */}
      {!showResults && (
        <section id="secondHero">

          <div id="search" style={{ marginTop: 30 }}>
            <SearchBar
              filters={filters}
              setFilters={setFilters}
              onSearch={handleSearch}
            />
          </div>

        </section>

      )}

      {/* 🔍 Search Results */}
      {showResults && (
        <>
          <div style={{ marginTop: 32 }}>
            <SearchBar
              filters={filters}
              setFilters={setFilters}
              onSearch={handleSearch}
            />
          </div>

          <RideResults filters={filters} user={user} />
        </>
      )}

      {!showResults && <HomeExtraSlides />}



      

     {/* 🚀 Travelo Promo Section */}
{!showResults && (
  <section className="split-promo">
    <div className="promo-image">
      <img src={rideshare1} alt="Travelo services" />
    </div>

    <div className="promo-text">
      <h1>Get Quick Rides, Low Fares</h1>
      <p>
        Travelo brings you autos, bikes, cars, and delivery — all at unbeatable prices.
      </p>

      <ul className="promo-points">
        <li>✅ Instant booking, no waiting</li>
        <li>💰 Save up to 60% on travel</li>
        <li>🌱 Eco‑friendly shared rides</li>
        <li>💬 Chat before you ride</li>
      </ul>

      <a href="#search" className="btn-book">Book a Ride →</a>
    </div>
  </section>
)}


      {/* 📱 DOWNLOAD APP
      {!showResults && (
        <section id="download" className="download-app">
          <div className="download-content">
            <div className="download-text">
              <h2>Get the Vyango App</h2>
              <p>Book rides faster, track trips live, and manage everything on the go.</p>

              <div className="store-buttons">
                <a
                  href="https://play.google.com/store/apps/details?id=com.netrosystems.vyango"
                  aria-label="Get Vyango on Google Play"
                  className="store-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >

                  <img
                    src={googleplay}
                    alt="Get it on Google Play"
                    loading="lazy" 
                  />
                </a>

              </div>

              <div className="download-small">
                <span className="muted">Or scan to download</span>
              </div>
            </div>

            <div className="qr-card">
              <img
                // src={"/assets/travelo-qr-code.png"}
                src={logo}
                alt="Scan QR to download the Travelo app"
                className="qr-image"
                loading="lazy"
              />
              <p className="qr-caption">Scan with your phone camera</p>
            </div>
          </div>
        </section>
      )} */}

      



    </div>
  );
}
